<template>

  <nav class="navbar is-primary">
    <div class="container">
      <div id="navMenu" class="navbar-menu">
        <div class="navbar-start">
          <a href="#" @click.prevent="setActive(key)" v-for="(menuItem, key) in menuItems" v-bind:key="key"
             :class="{'is-active' : menuItem.active}"
             class="navbar-item"
             :aria-current="menuItem.active ? 'page' : null">
            {{ menuItem.title }}
          </a>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons">
              <button class="button is-primary is-inverted is-outlined has-text-white logout-btn" @click="logout" title="Logout">
                <span class="icon has-text-white">
                  <i class="fas fa-sign-out-alt"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <div class="container">
    <section class="section">
      <div class="title">
        <h2 class="">{{ activeTitle }}</h2>
      </div>
      <div>
        <UsersComponent v-if="menuItems[0].active"></UsersComponent>
        <PreferencesComponent v-if="menuItems[1].active"></PreferencesComponent>
        <Records v-if="menuItems[2].active"></Records>
      </div>
    </section>
  </div>

</template>
<script>
import UsersComponent from '../components/users/Users'
import Records from "../components/records-usage/Records";
import PreferencesComponent from '../components/preferences/Preferences'
import { logoutRequest } from '../api/api'
import { auth } from '../auth/auth'

export default {
  name: 'Dashboard',
  components: {
    UsersComponent,
    PreferencesComponent,
    Records,
  },
  data() {
    return {
      menuItems: [
        {title: 'Users', active: true},
        {title: 'Preferences and Keywords', active: false},
        {title: 'Usage Records', active: false},
      ]
    }
  },
  methods: {
    setActive(key) {
      this.menuItems.forEach(item => {
        item.active = false
      })
      this.menuItems[key].active = true
      try {
        localStorage.setItem('lastActiveMenu', String(key))
      } catch (_) {
        // ignore storage errors
      }
    },
    async logout() {
      try {
        await logoutRequest()
      } catch (e) {
        // Best-effort: even if backend call fails, proceed to clear and redirect
        // console.error(e)
      } finally {
        try {
          auth.logout()
        } catch (_) {
          // ignore
        }
        try {
          window.location.assign('/')
        } catch (_) {
          // ignore
        }
      }
    }
  },
  created() {
    // Restore last active menu from storage if valid
    try {
      const raw = localStorage.getItem('lastActiveMenu')
      const idx = raw != null ? parseInt(raw, 10) : NaN
      if (!Number.isNaN(idx) && idx >= 0 && idx < this.menuItems.length) {
        // initialize active state
        this.menuItems.forEach(item => { item.active = false })
        this.menuItems[idx].active = true
      }
    } catch (_) {
      // ignore storage errors
    }
  },
  computed: {
    activeTitle() {
      return this.menuItems.filter((i) => {
        return i.active
      })[0].title
    }
  }
}
</script>

<style scoped>
.button.is-primary.is-inverted.is-outlined:hover {
  background-color: hsl(171, 100%, 41%) !important;
  border-color: hsl(171, 100%, 41%) !important;
  color: white !important;
}

.button.is-primary.is-inverted.is-outlined:hover .icon {
  color: white !important;
}
</style>

